import {
  Sticky as ReactSticky,
  StickyProps as ReactStickyProps,
  StickyContainer,
} from 'react-sticky';
import { FC, PropsWithChildren } from 'react';

type StickyProps = PropsWithChildren<ReactStickyProps>;

const Sticky: FC<StickyProps> = ({ children, ...rest }) => (
  <ReactSticky {...rest}>{children}</ReactSticky>
);

export { Sticky, StickyContainer, type StickyProps };
